<template>
  <div :class="classObj" class="app-wrapper">
    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
    <sidebar class="sidebar-container" v-show="isShowSidebar != 'false'&&$route.meta.showSide&&!isSetPaper" />
    <div class="main-container" :class="{'marginLeft0':isShowSidebar=='false'||!$route.meta.showSide||isSetPaper}" >
      <div :class="{'fixed-header':fixedHeader}">
        <navbar v-show="isShowSidebar != 'false'&&$route.meta.showSide&&!isSetPaper" />
      </div>
      <app-main />
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import Cookies from 'js-cookie'
export default {
  name: 'Layout',
  components: {
    Navbar,
    Sidebar,
    AppMain
  },
  data() {
    return {
      isShowSidebar: 'true',
      isSetPaper:false,
    }
  },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    fixedHeader() {
      return this.$store.state.settings.fixedHeader
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    },
    // 侧边栏是否隐藏
    getSidebarShowFun() {
      this.isShowSidebar = Cookies.get('isShowSidebar')
      // let Authorization = localStorage.getItem('Authorization')
      // if(!Authorization){      //没有侧边栏控制字段
      //   Authorization = Cookies.get('Authorization')
      //   // localStorage.setItem('Authorization',Authorization)
      // }
    }
  },
  
  mounted() {
    // this.isSetPaper=this.$route.query.isSetPaper;
    if(this.$route.query.isSetPaper){
      this.isSetPaper=true;
    }
   
    
    this.getSidebarShowFun()
  }
  
}
</script>

<style lang="scss" scoped>
  @import "~@/styles/mixin.scss";
  @import "~@/styles/variables.scss";

  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
    &.mobile.openSidebar{
      position: fixed;
      top: 0;
    }
  }
  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  .fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    width: calc(100% - #{$sideBarWidth});
    transition: width 0.28s;
  }

  .hideSidebar .fixed-header {
    width: calc(100% - 54px)
  }

  .mobile .fixed-header {
    width: 100%;
  }
  #app .main-container.marginLeft0{
    margin:0;
  }
  #app .main-container#marginLeft02{
    margin:0;
  }
  #app .main-container.marginLeft180{
    margin-left:$sideBarWidth;
  }
</style>
